import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, empty} from 'rxjs';
import {AgentService} from '../services/agent.service';
import {Agent} from '../classes/agent';
import { PreRenderService } from '../services/pre-render.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AgentResolver implements Resolve<Agent> {

  constructor(private _agentService: AgentService, private _router: Router, private _preRenderService: PreRenderService) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<Agent> {
    let agentId = '';
    const agentIdRegex = /(-+)(\D?\d+)-ag/;

    const agentIdMatches = agentIdRegex.exec(route.url[1].path);
    if (agentIdMatches) agentId = agentIdMatches[agentIdMatches.length - 1];

    return this._agentService.getAgentDetails(agentId)
      .pipe(catchError((err) => {
        this._router.navigate(['/find-agent-or-office/agent']);
        this._preRenderService.setPreRenderFlag(301, 'find-agent-or-office/agent');
        return empty();
      }));
  }
}
